import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GameComponent } from './game/game.component';
import { CookieService } from 'ngx-cookie-service';
import { HomeComponent } from './home/home.component';
import { GanadoresComponent } from './ganadores/ganadores.component';
import { ResultadoComponent } from './resultado/resultado.component';
import { PremiosComponent } from './premios/premios.component';
import { NavigationComponent } from './screen/navigation/navigation.component';
import { ConfigComponent } from './config/config.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [
    AppComponent,
    GameComponent,
    HomeComponent,
    GanadoresComponent,
    ResultadoComponent,
    PremiosComponent,
    NavigationComponent,
    ConfigComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [CookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }
